import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { AccentColor } from 'helpers/AccentColorHelper';
import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { DaysBetween } from 'helpers/DateHelper';

class PasswordExpiring extends Component {
  daysUntilExpiration = () => {
    const { currentRoute, passwordExpirationDate } = this.props;
    if (!passwordExpirationDate) return null;
    const daysUntilExpiration = DaysBetween(new Date(), new Date(passwordExpirationDate));
    if (
      daysUntilExpiration > 14 ||
      currentRoute === '/companies/companies/agent_change_password_reset'
    ) {
      return null;
    }

    return daysUntilExpiration;
  };

  changePassword = () => {
    this.props.hideExpiringPasswordDialog();
    browserHistory.push(this.props.changePasswordURL);
  };

  render() {
    const daysUntilExpiration = this.daysUntilExpiration();
    if (!daysUntilExpiration) return <span />;
    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={this.props.expiringDialogOpen}
        onClose={this.props.hideExpiringPasswordDialog}
        aria-labelledby="password-expiring"
      >
        <DialogTitle id="add-new-template">
          <h3 style={{ textAlign: 'center', margin: 0 }}>Password expiring soon</h3>
        </DialogTitle>
        <DialogContent>
          <div>
            <p style={{ textAlign: 'center' }}>
              Your password is due to expire in <strong>{daysUntilExpiration} days.</strong> Failure
              to update your password by this time will lock your account.
            </p>
          </div>
        </DialogContent>
        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={this.props.hideExpiringPasswordDialog}
            id="later-button"
            style={{ color: AccentColor() }}
          >
            Later
          </FlatButton>
          <FlatButton
            variant="raised"
            onClick={this.changePassword}
            id="change-password-button"
            style={{
              color: 'white',
              backgroundColor: AccentColor(),
              float: 'right',
              padding: '0px 15px',
            }}
          >
            Change Password
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(PasswordExpiring);
